import React, { useState } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { deviceSize } from "../../components/responsive";
import { Link } from "react-scroll";
import image170 from "../../images/Rectangle190.svg";
import image170mobile from "../../images/Rectangle190Mobile.svg";
import GinaVideo from "../../images/video/ExpedientStaffing_V8.mp4";
import { BusinessInquiriesForm } from "../form";

const AboutContainer = styled.div`
  width: 100%;
  position: relative;
  /* z-index: -1; */
  height: 850px;
  background: url(${image170}) no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 50px;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    background: url(${image170mobile});
    /* background-position: 54% 90%; */
    /* background-size: cover; */
  }
`;

const AboutWrapper = styled.div`
  width: 100%;
  display: grid;
  z-index: 1;
  height: 800px;
  width: 100%;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  justify-content: center;
  height: max-content;

  @media screen and (max-width: ${deviceSize.mobile}px) {
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-right: 0;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
  }
`;

const AboutRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: "col2 col1";

  @media screen and (max-width: ${deviceSize.tablet}px) {
    grid-template-areas: "col2 col2" "col1 col1";
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    grid-template-areas: "col2 col2" "col1 col1";
  }
`;

const Column1 = styled.div`
  margin-bottom: 15px;
  grid-area: col2;
  @media screen and (max-width: ${deviceSize.mobile}px) {
  }
`;

const Column2 = styled.div`
  margin-bottom: 1px;
  padding: 0 0px 0 0;
  grid-area: col1;
  @media screen and (max-width: ${deviceSize.mobile}px) {
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
`;

const TopLine = styled.h1`
  letter-spacing: 1.4px;
  margin-bottom: 50px;
  margin-top: 50px;
  align-items: center;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 41px;
  color: #9d2222;
  text-align: left;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    padding-left: 2%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    width: 100%;
    height: 33px;
    font-size: 28px;
    text-align: center;
    margin: 10px auto 45px auto;
  }
`;

const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 20px;
  font-size: 18px;
  color: #282828;
  text-align: left;
  font-family: "SunFlower", "Helvetica", "arial";
  line-height: 1.3;
  font-style: normal;
  font-weight: 300;
  line-height: 25px;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    padding-left: 2%;
    margin-bottom: 5px;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    margin-right: auto;
    margin-left: auto;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 15px;
    line-height: 1;
    width: 90%;
  }
`;

export const ImgWrap = styled.div`
  width: 100%;
  height: 100%;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    width: 90%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    width: 100%;

    margin-right: auto;
    margin-left: auto;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
  }
`;

const ImgText = styled.p`
  font-family: "Roboto", "Helvetica", "arial";
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  color: #747474;
`;

export const Video = styled.video`
  width: 524px;
  height: 375px;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    height: 375px;
    width: 90%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    width: 80%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    height: 377px;
    width: 80%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 245px;
    height: 181px;
  }
`;

const ContactButton = styled.button`
  border: 1px solid #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  outline: none;
  color: #fff;
  padding: 6px 1em;
  border-radius: 50px;
  font-family: "Sunflower", "Helvetica", "arial";
  font-size: ${({ size }) => (size ? size + "px" : "18px")};
  font-weight: 500;
  background-color: rgba(0, 0, 0, 0.65);
  transition: all 200ms ease-in-out;

  &:hover {
    color: #fff;
    background-color: #9d2222;
    border: 2px solid #ffffff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 50px;
  }
  &:focus {
    outline: none;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2; /* Make sure it's on top of your page content */
`;

const ModalContent = styled.div`
  padding: 20px;
  border-radius: 8px;
`;

export function About() {
  const isTablet = useMediaQuery({ maxWidth: deviceSize.tablet });
  const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });

  const [isFormVisible, setIsFormVisible] = useState();

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  const closeForm = (e) => {
    if (e.target.id === "modal-overlay") {
      setIsFormVisible(false);
    }
  };

  return (
    <AboutContainer>
      <AboutWrapper id="about-wrapper">
        <AboutRow>
          <Column1>
            <TextWrapper>
              <TopLine>Who We Are</TopLine>
              <Subtitle>
                Founded in 2002, Exp Staffing is a certified WBE (Woman-Owned
                Business Enterprise) staffing company that offers a broad range
                of scalable, yet cost efficient human capital workforce
                solutions. Our clients run the gamut from small businesses to
                Fortune 500 companies as well as NYC and NY State agencies.
              </Subtitle>
              <Subtitle>
                Each of these organizations is unique. With that in mind, we
                tailor a solution to fit your unique needs while maximizing
                staffing and recruiting potential.
              </Subtitle>
              {isTablet && (
                <ImgWrap>
                  <Video
                    width="100%"
                    controls
                    disablePictureInPicture
                    controlsList="nodownload"
                  >
                    <source src={GinaVideo} type="video/mp4" />
                    Sorry, Your browser doesn't support videos.
                  </Video>
                  <ImgText>Gina Herrera, CEO</ImgText>
                </ImgWrap>
              )}
              <Subtitle>
                Unlocking that potential requires a solid foundation. For over
                30 years, Gina has leveraged her skills in recruiting, training,
                and analytics to negotiate complex agreements that help
                organizations build their workforce.
              </Subtitle>
              <Subtitle>
                Ready to lay your foundation? Reach out—we’re all ears.
              </Subtitle>
              {isMobile && (
                <Link
                  activeClass="active"
                  to="homeScroll"
                  playsInline
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  style={{
                    float: "left",
                    marginTop: "15px",
                  }}
                >
                  <ContactButton Size={41} onClick={toggleFormVisibility}>
                    Contact Us
                  </ContactButton>
                </Link>
              )}

              {!isTablet && (
                <Link
                  activeClass="active"
                  to="homeScroll"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  style={{
                    float: "left",
                    marginTop: "15px",
                  }}
                >
                  <ContactButton Size={23} onClick={toggleFormVisibility}>
                    Contact Us
                  </ContactButton>
                </Link>
              )}
            </TextWrapper>
          </Column1>
          <Column2>
            {!isTablet && (
              <ImgWrap>
                <Video
                  width="100%"
                  controls
                  disablePictureInPicture
                  controlsList="nodownload"
                  autoPlay
                  loop
                  muted
                >
                  <source src={GinaVideo} type="video/mp4" />
                  Sorry, Your browser doesn't support videos.
                </Video>
                <ImgText>Gina Herrera, CEO</ImgText>
              </ImgWrap>
            )}
          </Column2>
        </AboutRow>
        {isFormVisible && (
          <ModalOverlay id="modal-overlay" onClick={closeForm}>
            <ModalContent id="modal-content">
              <BusinessInquiriesForm onClose={toggleFormVisibility} />
            </ModalContent>
          </ModalOverlay>
        )}
      </AboutWrapper>
    </AboutContainer>
  );
}
